import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../../../../tms-shared';
import {
  PickingListReport,
  SalesOrderConfirmationBalanceReport,
  SalesOrderConfirmationReport,
  SalesOrderDepositReport,
  SalesOrderProformaReport,
} from '../../../models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderReportsService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('SalesOrderReports', httpService);
  }

  getSalesOrderConfirmation(id: string): Observable<SalesOrderConfirmationReport> {
    return this.httpService.get<SalesOrderConfirmationReport>(`${this.apiUrl}/SalesOrderConfirmation?id=${id}`);
  }

  getSalesOrderConfirmationForPurchaseDelivery(id: string): Observable<SalesOrderConfirmationReport> {
    return this.httpService.get<SalesOrderConfirmationReport>(
      `${this.apiUrl}/SalesOrderConfirmationForPurchaseDelivery?id=${id}`,
    );
  }

  getSalesOrderProforma(id: string): Observable<SalesOrderProformaReport> {
    return this.httpService.get<SalesOrderProformaReport>(`${this.apiUrl}/SalesOrderProforma/${id}`);
  }

  getPickingList(id: string, supplierDocument: boolean): Observable<PickingListReport> {
    return this.httpService.get<PickingListReport>(
      `${this.apiUrl}/PickingList?id=${id}&supplierDocument=${supplierDocument}`,
    );
  }

  getSalesOrderBalances(id: string): Observable<SalesOrderConfirmationBalanceReport> {
    return this.httpService.get<SalesOrderConfirmationBalanceReport>(
      `${this.apiUrl}/SalesOrderConfirmationBalances/${id}`,
    );
  }

  getSalesOrderDeposits(id: string): Observable<SalesOrderDepositReport> {
    return this.httpService.get<SalesOrderDepositReport>(`${this.apiUrl}/SalesOrderDeposit/${id}`);
  }
}
